// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Import Turbolinks fixer first to patch addEventListener before other scripts run
import "packs/after_sales_turbolinks_fixer"

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// Load jQuery and expose it globally BEFORE other plugins that depend on it
const jQuery = require("jquery")
window.$ = window.jQuery = jQuery
global.$ = global.jQuery = jQuery

require("alpinejs")
require("select2")
require("easy-autocomplete")
require("@nathanvda/cocoon")

// Import Tailwind CSS
import '../stylesheets/application.scss'

// DataTables is loaded via CDN in the application layout
// The webpack imports below have been removed to avoid conflicts with CDN-loaded DataTables
// DO NOT re-enable these imports - they cause conflicts with the CDN version
// require('datatables.net-dt')(window, $)
// require('datatables.net-buttons-dt')(window, $)
// require('datatables.net-buttons/js/buttons.colVis.js')(window, $)
// require('datatables.net-buttons/js/buttons.html5.js')(window, $)
// require('datatables.net-buttons/js/buttons.print.js')(window, $)
// require('datatables.net-responsive-bs')(window, $) // Bootstrap version - conflicts with Tailwind
// require('datatables.net-select')(window, $)

// Import Select2 CSS
import 'select2/dist/css/select2.css';

// Initialize Select2 on turbolinks:load
document.addEventListener("turbolinks:load", function() {
  $('.select2').select2();
  
  // Initialize Cocoon for nested forms
  $(document).on('cocoon:after-insert', function() {
    // Re-initialize select2 on newly added nested form elements
    $('select.select2').select2();
  });
});

// Import Chart.js for analytics
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

// Import application JS
import "packs/people"
import "packs/datatable"
import "packs/sales_margin_forms"
import "./fcm_notifications"; // Ensure fcm_notifications is imported correctly

// Import After Sales page handlers for Turbolinks-compatible initialization
import "packs/after_sales_page_handlers"

// Import Select2 helper to ensure proper initialization with Turbolinks
import "packs/after_sales_select2_helper";

// Import Cocoon helper for nested forms
import "packs/after_sales_cocoon_helper";

// Import Year-End Closing custom confirmation
import "packs/year_end_closing";
